import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { post, patch } from '~/utils/adapi';
import FormInput from '~/components/form-input/FormInput.vue';
import FileUpload from '~/components/file-upload/FileUpload.vue';
import Markdown from '~/components/markdown/Markdown.vue';

export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    comment: {
      type: Object,
      required: true,
    },
  },
  components: {
    Markdown,
    'form-input': FormInput,
    'file-upload': FileUpload,
  },
  data() {
    return {
      text: null,
      files: [],
    };
  },
  computed: {
    ...mapState('genericConfig', ['config']),
    commentId() {
      return _.get(this.comment, 'id', null);
    },
    configuration() {
      if (!this.config) {
        this.updateGenericConfig();
      }
      return this.config;
    },
  },
  methods: {
    ...mapActions('genericConfig', {
      updateGenericConfig: 'updateConfig',
    }),
    getCommentData() {
      return {
        commentable_id: this.comment.commentable_id,
        commentable_type: this.comment.commentable_type,
        text: this.text,
        file_ids: this.files.map(file => Number(file.id)),
      };
    },
    updateComment() {
      if (!_.isEmpty(this.text)) {
        const dataToSend = this.getCommentData();
        return Promise.resolve(this.commentId
          ? patch(`comments/${this.commentId}`, null, dataToSend)
          : post('comments', null, dataToSend))
          .then(() => this.clearCommentData(this.commentId));
      }

      return Promise.reject(this.$t('pos.comment.please-fill-comment'));
    },
    clearCommentData(id = null) {
      this.text = null;
      this.files = [];
      if (!id) {
        this.$refs.upload.$refs.fileUpload.removeAllFiles();
      }
    },
    submit() {
      this.$emit('submit', { text: this.text, files: this.files });
    },
  },
  watch: {
    comment: {
      immediate: true,
      handler(comment) {
        this.text = _.get(comment, 'text', null);
        this.files = _.get(comment, 'files', [])
          .map(file => ({
            id: file.id,
            name: file.file_name,
            size: file.file_size,
            path: file.path,
            type: file.content_type,
            thumbnail: file.thumbnail,
          }));
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/comment/Comment.js